// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"yX-z","inlineTitle":"zX-z","sponsoredAdsWrapper":"AX-z","marketplaceRecosWrapper":"BX-z"};